module.exports = __webpack_public_path__ + "img/python.dc687518.png";